export class GetRoles {
    static type = '[Role] Get roles';
}
